import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { UserIdleService } from 'angular-user-idle';
import {AuthenticationService} from '../services/authentication.service';
import {GeneralService} from '../services/general.service';
import { SignImageService} from '../services/sign-image.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class EncrDecrServiceService {

  constructor(private authService : AuthenticationService, private userIdle: UserIdleService,private generalService : GeneralService,public signService: SignImageService,private router: Router) {

  }

  set(keys, value){
    var key = CryptoJS.enc.Utf8.parse(keys);
    var iv = CryptoJS.enc.Utf8.parse(keys);
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
    {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.toString();
  }

  //The get method is use for decrypt the value.
  get(keys, value){
    var key = CryptoJS.enc.Utf8.parse(keys);
    var iv = CryptoJS.enc.Utf8.parse(keys);
    var decrypted = CryptoJS.AES.decrypt(value, key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }

   //The get method is use for decrypt the value.
  getnew(keys, encryptedvalue){
    let finalkey = keys;

    var encrypted_json = JSON.parse(atob(encryptedvalue));
    let decrypted =  CryptoJS.AES.decrypt(encrypted_json.value, CryptoJS.enc.Base64.parse(finalkey), {
        iv : CryptoJS.enc.Base64.parse(encrypted_json.iv)
    }).toString(CryptoJS.enc.Utf8);
    //console.log('decrypted is ',decrypted);
    if(decrypted.indexOf('s:9:') > -1){
      let finaldecrypted = decrypted.split('s:9:')[1];
      finaldecrypted = finaldecrypted.replace(/"/g, "");
      finaldecrypted = finaldecrypted.replace(/;/g, "");
      //console.log('finaldecrypted',finaldecrypted);
      return finaldecrypted;
    } else if(decrypted.indexOf('s:10:') > -1){
      let finaldecrypted = decrypted.split('s:10:')[1];
      finaldecrypted = finaldecrypted.replace(/"/g, "");
      finaldecrypted = finaldecrypted.replace(/;/g, "");
      //console.log('finaldecrypted',finaldecrypted);
      return finaldecrypted;
    } else if(decrypted.indexOf(':') > -1){
      let extractdecrypted = decrypted.split(':');
      let finaldecrypted = extractdecrypted[extractdecrypted.length-1];
      finaldecrypted = finaldecrypted.replace(/"/g, "");
      finaldecrypted = finaldecrypted.replace(/;/g, "");
      if(finaldecrypted != ''){
        finaldecrypted = finaldecrypted.trim();
        return finaldecrypted;
        //console.log('finaldecrypted is',finaldecrypted);
      }
    } else {
      return decrypted;
    }

  }

  checkInActivity(){
     // console.log('user is authenticated');
     this.userIdle.startWatching();

     // Start watching when user idle is starting.
     this.userIdle.onTimerStart().subscribe((count) => {

       //console.log('timer is running',count);
         let lasteventtime:number = Number(localStorage.getItem('lastEventTime'));

         if(typeof lasteventtime != 'undefined'){
           let currenttimestamp =  new Date().getTime();
           let expiresInMS = 20000;
           let totaltimestamp = lasteventtime + expiresInMS;
           if(totaltimestamp < currenttimestamp){
               //console.log('count is ',count,'lasteventtime',lasteventtime,'totaltimestamp',totaltimestamp,'currenttimestamp',currenttimestamp);
               let actiontaken:any = localStorage.getItem('actiontaken');
               if(actiontaken == '1'){
                 //console.log('come inside stop timer');
                 this.userIdle.stopTimer();
                 this.userIdle.resetTimer();
               }
           } else {
             let actiontaken:any = localStorage.getItem('actiontaken');
               if(actiontaken == '1'){
                 //console.log('come inside stop timer');
                 this.userIdle.stopTimer();
                 this.userIdle.resetTimer();
               }
           }

         }
     });

     // Start watch when time is up.
     this.userIdle.onTimeout().subscribe((response: any) => {

         if (document.getElementsByClassName("modal").length === 0) {
           //do something...
         } else {
           // do something when a modal is open
           this.signService.closeModal();
         }
         var fullRoute = this.router.url;
         //console.log("fullRoutefullRoutefullRoute===============",fullRoute);
          if (fullRoute.indexOf('quote') > -1 || fullRoute.indexOf('dealhub') > -1 ){
              this.authService.logout();
              this.userIdle.stopTimer();
              this.userIdle.stopWatching();
              this.generalService.showToasterErrorMessage("User logged out due to non activity");
              this.router.navigate(['/login']);
          }
       });
  }
}
